import Axios from '@/assets/js/AxiosPlugin'

// 会员信息
export const searchMemberInfo = params => { return Axios.post('/api/Admin/Member/searchMemberInfo', params) }

// 充值
export const memberRecharge = params => { return Axios.post('/api/Admin/Member/recharge', params) }

// 充值列表
export const getRechargeCouponList = params => { return Axios.post('/api/Admin/Public/getRechargeCouponList', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CashRechargeApp/apis/index.js